
import { Options } from "vue-class-component";

import BasePage from "@/common/BasePage"; // @ is an alias to /src

import UserVo from "@/vo/UserVo";
import { Icon } from "vant";
@Options({
  components: {
    [Icon.name]: Icon,
  },
})
/**BOOS中心 */
export default class ShareholderIndex extends BasePage {
  user: UserVo = UserVo.getInstance();

  _title = "BOOS中心";
  
  mounted() {
    if (!this.user.id) {
      this.user.req_data();
    }
  }
  /**返回用户端 */
  user_click() {
    this.$router.push({
      path: "/user",
    });
  }
}
